export default __webpack_public_path__ + "static/media/paymentgateway.00915c13.png";